import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import * as Containers from 'containers'
import { withRouter } from 'react-router-dom'

export class Routes extends Component{
  render = () =>
    <Switch>
      <Route exact path="/inactive"       component={Containers.Inactive} />
      <Route exact path="/error_occurred" component={Containers.ErrorOccurred} />
    </Switch>
}

export default withRouter(Routes)
